export const ERROR_MESSAGES = {
    DOB_FORMAT: 'Enter Date of Birth as MM/DD/YYYY.',
    AT_LEAST_ONE_FIELD_REQUIRED: 'Enter search criteria for at least one of the fields.',
    VALID_SEARCH_CRITERIA: 'Please enter only one of the three search criterias',
    DOB_VALID_SEARCH_CRITERIA: 'Enter search criteria of at least one other field when using DOB as search criteria.',
    VALID_FIRST_NAME: 'First name cannot contain numbers or special characters like asterisks, periods, commas and parenthesis.',
    VALID_LAST_NAME: 'Last name cannot contain numbers or special characters like asterisks, periods, commas and parenthesis.',
    VALID_MIDDLE_INITIAL: 'Middle initial cannot contain numbers or special characters like asterisks, periods, commas and parenthesis.',
    VALID_EMAIL_FORMAT: 'The email address is not in valid format. Please try again.',
    VALID_SSN_FORMAT: 'SSN is not in valid format. Please try again.',
    VALID_MEMBER_USER_ID: 'Member User ID is not in valid format. Please try again.',
    BILLING_RESPONSE_NOT_AVAILABLE: 'Billing Response is not available. Cannot complete SSO',
};

export const NO_FOOTER_URLS = [
    'ccm',
    'self-funded',
    '/employer/',
    'provider',
    '/producer/',
    '/manage-csa-users/',
    '/member/',
    '/manage-oep',
    '/my-profile'
];

export const Constants = {
    APPLICATION_AUDIT: 'ADMIN_AUDIT',
    APPLICATION_DEBUG: 'CSADMIN_DEBUG',
    APPLICATION_INFO: 'CSADMIN_INFO',
    APPLICATION_ERROR: 'CSADMIN_ERROR',
    SPLUNK_SOURCE: 'dpadminservice',
    IPADDRESS_URL: 'https://api.ipify.org/?format=json',
    DEFAULT_IP: '1.1.1.1',
    UNAUTHUSER: 'UNAUTHUSER',
    APP_NAME: 'CSADMIN',
    DIGITAL: 'DIGITAL',
    WEB_PORTAL: 'WEB_PORTAL',
    API_VERSION: 'V1',
    HELP: 'help',
    CCM: 'ccm',
    DPADMIN: 'DPAdmin',
    UNAUTHORIZED_CODE: '401',
    INVALID_JWT_MSG: 'Jwt Token Validation Error',
    BENEFITS_ROUTE: '/benefits/benefit-lookup',
    SSO_REDIRECTION: 'sso-redirection',
    SSO_REDIRECTION_FULL_PATH: '/dpadminwebapp/sso-redirection',
    ZIPARI_ADMIN: 'Admin',
    IMAGE_BASE_PATH: '/dpadminwebapp/assets/images/',
    SELF_FUNDED: 'self-funded',
    SELF_FUNDED_VIEW_PERMISSIONS_ROUTE: 'view-permissions',
    EMPLOYER: 'employer',
    WHYZEN_APP_ID: 'Whyzen_BSCalifornia_Instance_1',
    BSC: 'BSC',
    CSA: 'CSA',
    WELCOME: 'Welcome',
    BSC_TITLE: 'Blue Shield CA - Customer Service Administration',
    PROVIDER_REPORTS_TITLE: 'Blue Shield of California - Provider Connection Administration',
    BENEFIT_LOOKUP_TITLE: 'Blue Shield of California - CSR Benefit Lookup',
    Y_FLAG: 'Y',
    N_FLAG: 'N',
    EXTU_ID: 'EXTU_ID',
    SUBSCRIBER: 'SUBSCRIBER',
    EN_US: 'en-US',
    MM_DD_YYYY: 'MM/dd/yyyy',
    EXCLUDE_BSCGroup: 'All-Restricted',
    INCLUDE_BSCGroup: 'All',
    SUCCESS: 'SUCCESS',
    FAILURE: 'FAILURE',
    PROSPECT: 'PROSPECT',
    MEMBER: 'MEMBER',
    SELF_FUNDED_PORTAL: 'SELF FUNDED',
    PROVIDER: 'PROVIDER',
    PRODUCER: 'PRODUCER',
    CONFIRM_TEXT: 'confirm delete'
};

export enum SsoApplicationType {
    MEMBER_PAYMENT_RESEARCH = 'MemberPaymentResearch',
    WHYZEN = 'whyzen',
    BROKER_CONNECTION = 'brokerConnectionDsa',
    BROKER_CONNECTION_ADMIN = 'brokerConnectionAdmin',
    ZIPARI = 'zipari',
    DRX = 'drx',
    OPEN_ADMIN_TOOL = 'openAdminTool',
    MEMBER = 'Member',
    SELF_ADMIN = 'selfAdmin',
    PROVIDER = 'Provider',
    PRODUCER = 'broker',
    EMPLOYER = 'ewa',
    MEMBER_MAKE_A_PAYMENT = 'makeapayment'
}

export enum SsoParameter {
    SSO = 'sso',
    SUBJECT = 'subject',
    USER_NAME = 'username',
    ACCOUNT_ID = 'accountid',
    APPLICATION_ID = 'applicationid',
    EMAIL_ADDRESS = 'email_address',
    ROLES = 'roles',
    BROKER_ID = 'broker_id',
    USER_ID = 'user_id',
    AGENCY_ID = 'agency_id',
    CSADMIN_USER_ID = 'csAdminUserId',
    BSC_PROFILE_UID = 'bscProfileuid',
    PROVIDER_USER_ID = 'providerUserId',
    SELF_ADMIN_USER_ID = 'selfAdminUserId',
    PRODUCER_USER_ID = 'producerUserId',
    BSC_USERNAME = 'bscUserName',
    EMPLOYER_USERID = 'spoofId',
    BROKER_DSA = 'dsa',
    BROKER_ADMIN = 'admin',
    SUBCRIBER_ID = 'subscriberId',
    EXTERNAL_USERID = 'extUId',
    FIRST_NAME = 'firstName',
    LAST_NAME = 'lastName',
    MIDDLE_NAME = 'middleName',
    EMAIL = 'emailAddress',
    PRE_CUTOVER_PAGE_USER_FLAG = 'preCutoverPageUserFlag',
    SOURCE_SYSTEM = 'sourceSystem',
    SUPPLEMENTAL_ID = 'Supplemental_Id',
    USR_ID = 'User_Id',
    USER_TYPE = 'User_Type',
    USER_ROLE = 'User_Role',
    MAKE_A_PAYMENT_FIRST_NAME = 'First_Name',
    DEFERRED_FLAG = 'Deferred_Flag',
    MAKE_A_PAYMENT_MIDDLE_NAME = 'Middle_Name',
    MAKE_A_PAYMENT_LAST_NAME = 'Last_Name',
    MAKE_A_PAYMENT_EMAIL = 'Email',
    PREMIUM_AMOUNT = 'Premium_Amount',
    PREMIUM_DUE_DATE = 'Premium_Due_Date',
    BILLING_PERIOD_START_DATE = 'Billing_Period_Start_Date',
    BILLING_PERIOD_END_DATE = 'Billing_Period_End_Date',
    MAKE_A_PAYMENT_SOURCE_SYSTEM = 'Source_System',
    LANGUAGE = 'Language',
    MAKE_A_PAYMENT_USER_ID = 'User_Id',
    MAKE_A_PAYMENT_MAIL = 'email'
}

export enum PingParameter {
    PARTNER_SP_ID = 'PartnerSpId',
    REF = 'REF',
    TARGET_RESOURCE = 'TargetResource',
    USER_TYPE = 'userType'
}

export const URL_PATHS = {
    WHYZEN_SSO: '/dpadminwebapp/sso-redirection?sso=whyzen&al='
};

export const SSO_SPLUNK = {
    SSO_DROPOFF: {
        SUCCESS_ID: '7102',
        SUCCESS_CODE: 'DPADMIN_DROP_OFF_SUCCESS',
        SUCCESS_DESCRIPTION: 'DPAdmin SSO attribute drop off in PING successful.',
        FAILURE_ID: '7103',
        FAILURE_CODE: 'DPADMIN_DROP_OFF_FAILURE',
        FAILURE_DESCRIPTION: 'DPAdmin SSO attribute drop off in PING failed.'
    },
    ZIPARI: {
        ID: '8100',
        CODE: 'DPADMIN_ZIPARI_PLANS_AND_ENROLL_SSO',
        DESCRIPTION: 'DPAdmin: Zipari Plans and Enroll SSO -'
    },
    MEMBER_SPOOF: {
        ID: '4136',
        CODE: 'DPADMIN_MEMBER_SPOOF_SSO',
        DESCRIPTION: 'DPAdmin: Member Spoof SSO -'
    },
    MEMBER_MAKE_A_PAYMENT: {
        ID: '4137',
        CODE: 'DPADMIN_MEMBER_MAKE_A_PAYMENT_SSO',
        DESCRIPTION: 'DPAdmin: Member Make A Payment SSO -'
    },
    MEMBER_PAYMENT_RESEARCH: {
        ID: '4138',
        CODE: 'DPADMIN_MEMBER_PAYMENT_RESEARCH_SSO',
        DESCRIPTION: 'DPAdmin: Member Payment Research SSO -'
    },
    SELF_ADMIN_SPOOF: {
        ID: '5121',
        CODE: 'DPADMIN_SELF_FUNDED_SPOOF_USER',
        DESCRIPTION: 'DPAdmin: Self Funder Portal Spoof User SSO -'
    },
    WHYZEN: {
        ID: '9128',
        CODE: 'DPADMIN_WHYZEN_SSO',
        DESCRIPTION: 'DPAdmin: Employer Whyzen SSO -'
    },
    EMPLOYER: {
        ID: '9129',
        CODE: 'DPADMIN_EMPLOYER_SSO',
        DESCRIPTION: 'DPAdmin: Employer Spoof User SSO -'
    },
    PROVIDER: {
        ID: '2251',
        CODE: 'DPADMIN_PROVIDER_SSO',
        DESCRIPTION: 'DPAdmin: Provider Spoof User SSO -'
    },
    PRODUCER: {
        ID: '3304',
        CODE: 'DPADMIN_PRODUCER_SSO',
        DESCRIPTION: 'DPAdmin: PRODUCER Spoof User SSO -'
    }

}